// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_QUESTION_SENT_TOAST = "\u010eakujeme za ot\u00e1zku, budeme sa sna\u017ei\u0165 ju \u010do najsk\u00f4r spracova\u0165. Ur\u010dite sa sem o p\u00e1r dn\u00ed vr\u00e1\u0165 a pre\u010d\u00edtaj si odpove\u010f.";
